import GptAd, { GptAdProps } from "./GptAd";

const LandingRailAd = (props: GptAdProps) => {
  return <GptAd format="rrail" sizesAt0="" sizesAt1010="rail" {...props} />;
};

export default LandingRailAd;
